import { snakeCase } from "lodash"

export class JsonApi {
  public static objectToJsonApi(type: string, data: any) {
    const { id, ...rest } = data

    const attributes: any = {}
    for (let attribute in rest) {
      attributes[snakeCase(attribute)] = rest[attribute]
    }

    const jsonApi = {
      id,
      type,
      attributes,
    }

    return jsonApi
  }

  public static arrayToJsonApi(type: string, data: any[]) {
    return data.map(d => JsonApi.objectToJsonApi(type, d))
  }

  public static objectToMinimalJsonApi(type: string, data: any) {
    const jsonApiObject = JsonApi.objectToJsonApi(type, data)
    delete jsonApiObject.attributes

    return jsonApiObject
  }
}
